<template>
    <div class="m-login animated fadeIn">
        <header class="login-header">
            <div class="head-container">
                <div class="logo-top" v-if="$i18n.locale === 'zh-CN'">
                    <img class="nuctech" src="../../assets/images/login/nuctech.png" alt="威视"/>
                    <!-- <img class="an-cloud" src="../../assets/images/login/logo.png" alt="安培云"/> -->
                    <label class="system-name1">安培云&nbsp;</label>
                    <label class="system-line">|</label>
                    <label class="system-name2">&nbsp;&nbsp;安检培训云平台</label>
                </div>
                <div class="logo-top" v-else>
                    <img class="nuctech" src="../../assets/images/login/nuctech_en.png" alt="威视"/>
                    <img class="product-name-en" src="../../assets/images/login/nuctech_product_en.png" alt="威视"/>
                </div>
                <div class="header-right">
                    <a v-bind:href="homeUrl" style="font-size: 16px;">{{$t('app.portal')}}</a>
                    <el-dropdown trigger="click" @command="switchLang">
                        <div class="operate-btn changeLang">
                            <span>{{language}}</span>
                            <i class="nucfont inuc-caret-down"></i>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
                            <el-dropdown-item command="en">English</el-dropdown-item>
                            <el-dropdown-item command="es">Español</el-dropdown-item>
                            <el-dropdown-item command="pt-BR">Português Brazileiro</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </header>

        <section class="login-main">
            <div class="login-box">
                <h3 class="login-title"><span>{{loginTitle}}</span></h3>
                <!-- <div class="login-method">
                    <a>
                        <i v-if="loginMethod!=='pwd'" @click="loginMethod='pwd'" class="nucfont inuc-by_password"></i>
                        <i v-else @click="loginMethod='scan'" class="nucfont inuc-qrcode"></i>
                    </a>
                    <div class="tips">
                        <div class="arrow"><em></em><span></span></div>
                        <span>{{loginMethod!=='pwd' ? $t('app.pwdLogin') : $t('app.scanLogin')}}</span>
                    </div>
                </div> -->

                <!-- 登录表单 -->
                <div v-if="loginMethod!=='scan'" class="by-form">

                    <!-- 密码登录 -->
                    <pwd-form v-if="loginMethod==='pwd'" ref="pwdForm"></pwd-form>

                    <!-- 短信登录 -->
                    <sms-form v-if="loginMethod==='sms'" ref="smsForm"></sms-form>

                    <!-- 短信登录 -->
                    <job-no-form v-if="loginMethod==='jobNo'" ref="jobNoForm"></job-no-form>

                    <!-- 忘记密码 -->
                    <p v-if="loginMethod==='pwd' || loginMethod==='jobNo'" class="forget-pwd">
                        <a @click="forgetVisible=true">{{$t('app.forgetPwd')}}</a>
                    </p>

                    <div class="login-submit">
                        <el-button class="but_a"
                                   size="small"
                                   @click.prevent="login"
                                   :loading="loading"
                        >{{loading ? $t('app.logining') : $t('app.loginNow')}}

                        </el-button>
                    </div>

                    <div class="login-others">
                        <a @click="loginMethod = 'sms'" class="login-sms">
                            <i class="nucfont inuc-feedback"></i>{{$t('app.smsLogin')}}
                        </a>
                        <a @click="loginMethod = 'jobNo'" class="login-jobNo">
                            <i class="nucfont inuc-members"></i>{{$t('app.jobNoLogin')}}
                        </a>
                        <a @click="faceLoginVisible = true" class="login-face">
                            <i class="nucfont inuc-person-scan"></i>{{$t('app.faceLogin')}}
                        </a>
                    </div>
                </div>

                <!-- 扫码登录 -->
                <div v-if="loginMethod==='scan'" class="by-scan">
                    <scan-login @scanLoginSuccess="otherLoginSuccess"></scan-login>
                </div>
            </div>

        </section>

        <footer class="login-footer">
            <p>{{$t('app.copyright')}}</p>
        </footer>

        <!-- 忘记密码 -->
        <forget-pwd :dialog-open.sync="forgetVisible"></forget-pwd>

        <!-- 人脸登录 -->
        <el-dialog
            top="5vh"
            :title="$t('app.faceLogin')"
            :visible.sync="faceLoginVisible"
            width="520px"
            :append-to-body="true"
            :close-on-click-modal="false"
        >
            <face-login v-if="faceLoginVisible" @faceLoginSuccess="otherLoginSuccess"></face-login>
        </el-dialog>
    </div>
</template>

<script>
    import api from "@/api"
    import {Storage, Ticket} from "@/utils"
    import FaceLogin from './FaceLogin'
    import ScanLogin from './ScanLogin'
    import ForgetPwd from './forgetPwd'
    import PwdForm from './Components/PwdForm'
    import SmsForm from './Components/SmsForm'
    import JobNoForm from './Components/JobNoForm'

    const config = require("@/config")

    export default {
        components: {
            FaceLogin,
            ScanLogin,
            ForgetPwd,
            PwdForm,
            SmsForm,
            JobNoForm
        },
        data() {
            return {
                loading: false,
                forgetVisible: false,
                faceLoginVisible: false,
                homeUrl: config.homeUrl,

                // 登录方式: pwd扫码登录 sms短信登录 jobNo工号登录 scan扫码登录 face人像登录
                loginMethod: 'pwd',
            }
        },
        mounted() {
            $(document).on("keydown", e => {
                if (e.keyCode === 13 && this.loginMethod!=='scan') {
                    this.login()
                }
            })
        },
        computed: {
            language() {
                return {
                    'zh-CN': '中文',
                    'en': 'English',
                    'es': 'Español',
                    'pt-BR': 'Português Brazileiro'
                }[this.$i18n.locale]
            },
            loginTitle() {
                return {
                    'pwd': this.$t('app.pwdLogin'),
                    'scan': this.$t('app.scanLogin'),
                    'sms': this.$t('app.smsLogin'),
                    'jobNo': this.$t('app.jobNoLogin')
                }[this.loginMethod]
            }
        },
        methods: {
            // 用户登录
            login() {
                this.loading = true

                let formName = {
                    'pwd': 'pwdForm',
                    'sms': 'smsForm',
                    'jobNo': 'jobNoForm'
                }[this.loginMethod]

                Ticket.remove()
                Storage.set('userPwd',null)
                this.$refs[formName].login().then(result => {
                    Ticket.set(result.package)

                    return api.getUserMenus()
                })
                    .then(res => {
                        if (!Ticket.get()) return Promise.reject()

                        if (!res.package.length) {
                            this.$message(this.$t('m.emptyMenuLogin'))
                            return Promise.reject()
                        }

                        this.initData(res.package)
                    })
                    .catch(err => {
                        console.warn(err)
                        this.loading = false
                    })
            },

            otherLoginSuccess(data) {
                Ticket.set(data)

                api.getUserMenus().then(res => {
                    if (!res.package.length) {
                        this.$message(this.$t('m.emptyMenuLogin'))
                        return Promise.reject()
                    }

                    this.initData(res.package)

                    // if (res.package[0].children.length) {
                    //     this.$router.push(res.package[0].children[0].path)
                    // } else {
                    //     this.$router.push(res.package[0].path)
                    // }
                })

            },
            // 初始化vuex数据、菜单持久化及跳转
            initData(menuData) {

                // 1. 初始化主题、用户数据和系统信息
                this.$store.commit("initAppTheme")
                this.$store.commit("initUserInfo")
                this.$store.dispatch("getSystemInfo")

                // 2. 初始化学员和培训师的dashboard，并跳转
                // type: 1管理员 2培训师 3学员 4超管
                let {type, userID} = Ticket.get()

                let dashboard = {
                    // 培训师
                    2: {
                        name: this.$t('app.dashboard'),
                        path: "/teacher/home",
                    },
                    // 学员
                    3: {
                        name: this.$t('app.dashboard'),
                        path: "/student/home",
                    }
                }

                if (type === 2 || type === 3) {
                    // 处理学员的菜单，过滤掉外层菜单
                    if (type === 3) {
                        let studentMenu = []
                        menuData.forEach(item => {
                            if (item.children && item.children.length) {
                                item.children.forEach(v => {
                                    studentMenu.push(v)
                                })
                            } else {
                                studentMenu.push(item)
                            }
                        })
                        menuData = studentMenu
                    }

                    menuData.unshift({
                        id: 0,
                        order: 0,
                        superiorID: null,
                        name: dashboard[type].name,
                        iconClass: "inuc-dashboard",
                        path: dashboard[type].path,
                        children: []
                    })

                    this.$router.push(dashboard[type].path)
                } else {
                    if (menuData[0].children.length) {
                        this.$router.push(menuData[0].children[0].path)
                    } else {
                        if (menuData[0].path) {
                            this.$router.push(menuData[0].path)
                        } else {
                            this.$router.push({name: 'info'})
                        }
                    }
                }

                // 3. 存储菜单数据
                Storage.set("menu", menuData)

                console.log("用户信息", Ticket.get())
            },

            switchLang(lang) {
                this.$i18n.locale = lang
                Storage.set('lang', lang)
                this.$router.go(0)
            },
        },
        destroyed() {
            $(document).off("keydown")
        }
    }
</script>

<style scoped lang="scss">
    @import "../../style/const";

    $headerHeight: 100px;
    $footerHeight: 110px;
    $mainColor: #4081dd;
    $borderColor: #999;

    .m-login {
        height: 100%;
        display: flex;
        flex-direction: column;

        .login-header {
            .head-container {
                display: flex;
                justify-content: space-between;
                height: $headerHeight;
                min-width: 960px;
                width: 70%;
                margin: auto;
            }

            .logo-top {
                display: flex;
                align-items: center;

                .nuctech {
                    height: 45px;
                    margin-right: 30px;
                }
                .system-name1{
                    font-size: 35px;
                    letter-spacing: 2px;
                    color: #000;
                }
                .system-line{
                    font-size: 29px;
                }
                .system-name2{
                    font-size: 20px;
                    letter-spacing: 1px;
                    color: #000;
                    padding-top: 4px;
                }
            }

            .header-right {
                display: flex;
                align-items: center;

                > a {
                    padding-right: 15px;
                    margin-right: 15px;
                    font-size: 16px;
                    border-right: 1px solid #999;
                    color: #000;
                }

                > a, .changeLang {
                    &:hover {
                        color: $mainColor;
                    }
                }

                .changeLang {
                    font-size: 16px;
                    color: #333;
                    cursor: pointer;
                }
            }
        }

        .login-main {
            position: relative;
            flex: 1;
            overflow: hidden;
            background-image: url(../../assets/images/login/login_bg.jpg);
            background-size: cover;
            background-position: left;
        }

        .login-box {
            position: absolute;
            right: 15%;
            top: 50%;
            transform: translateY(-50%);
            width: 360px;
            min-height: 350px;
            max-height: 456px;
            padding: 40px 36px 0 36px;
            background-color: #fff;
            overflow: hidden;
            @media screen and (max-width: 1366px) {
                right: 10%;
            }

            .login-title {
                margin-bottom: 30px;
                padding-bottom: 4px;
                border-bottom: 1px solid $borderColor;
                color: #2b2223;
                font-size: 20px;
                text-align: left;

                > span {
                    padding: 0 5px 4px;
                    border-bottom: 3px solid $mainColor;
                }
            }

            .login-method {
                > a {
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    cursor: pointer;
                }

                .nucfont {
                    font-size: 42px;
                    color: #999;
                }

                .tips {
                    $innerColor: #e6f9fc;
                    position: absolute;
                    top: 5px;
                    right: 52px;
                    padding: 5px 10px;
                    background-color: $innerColor;
                    color: $mainColor;
                    border: 1px solid $mainColor;

                    .arrow {
                        position: absolute;
                        top: 8px;
                        right: 0;

                        em {
                            position: absolute;
                            left: 1px;
                            width: 0;
                            height: 0;
                            border-top: 5px solid transparent;
                            border-bottom: 5px solid transparent;
                            border-left: 5px solid $mainColor;
                        }

                        span {
                            @extend em;
                            left: 0;
                            border-left: 5px solid $innerColor;
                        }
                    }
                }
            }
        }

        .login-submit {
            padding: 15px 0 22px 0;

            .but_a {
                display: block;
                width: 100%;
                margin: 0 auto;
                font-size: 18px;
                color: #fff;
                background: $mainColor;
            }
        }

        .by-form {

            .forget-pwd {
                margin-top: -5px;
                font-size: 13px;
                color: $borderColor;
                text-align: right;

                a {
                    cursor: pointer;

                    &:hover {
                        color: #f40;
                    }
                }
            }

            .login-others {
                display: flex;
                justify-content: center;
                height: 48px;
                line-height: 48px;
                margin: 0 -48px;
                padding: 0 20px;
                background-color: #fcfcfc;
                border-top: 1px solid #f4f4f4;

                > a {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    font-size: 13px;
                    transition: all .3s;

                    + a:before {
                        content: '|';
                        padding: 0 10px;
                        color: #ccc;
                    }

                    .nucfont {
                        margin-right: 5px;
                        color: #67c23a;
                    }

                    &:hover {
                        &, .nucfont {
                            color: #67c23a;
                        }
                    }
                }
            }
        }

        .login-footer {
            height: $footerHeight;
            line-height: $footerHeight - 20px;
            text-align: center;
            background: #fff;
            bottom: 0;
            color: #666;
            letter-spacing: 1px;
        }
    }

    .theme-festival {
        .login-main {
            background-image: url(~@/assets/images/login/bg_100.jpg);
            background-position: top;
        }
        .login-box {
            border-radius: 4px;
        }
    }

    .app-root:not(.lang-zh-CN) {
        .login-box {
            width: 400px;
        }
        .login-others a {
            font-size: 12px;
        }
    }

    .app-root.lang-pt-BR {
        .login-box {
            width: 440px;
        }
    }
</style>
<style lang="scss">
    .m-login {
        .form-item {
            position: relative;
            margin: 20px auto;
            padding-bottom: 5px;

            i {
                position: absolute;
                z-index: 10;
                left: 8px;
                color: #999;
            }

            .el-input__inner {
                padding: 0 15px 0 30px;
            }
        }
        .jobNo-form {
            .form-item {
                margin: 15px auto;
            }
        }
    }
</style>
